/**
 * Status da Inspeção
 * Esse enum representa o status customizado da inspeção, mapeado para InspectionStatus do InsureMO
 */
export enum InspectionStatus {
  /** Requisitada */
  Requested = 'requested',
  /** Em andamento */
  InProgress = 'in_progress',
  /** Frustada */
  Frustrated = 'frustrated',
  /** Cancelada */
  Canceled = 'canceled',
  /** Em revisão */
  UnderReview = 'under_review',
  /** Aprovada */
  Accepted = 'accepted',
  /** Rejeitada */
  Dismissed = 'dismissed',
  /** Pendente */
  Pending = 'pending',
  /** Completada */
  Completed = 'completed',
}
